"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArcgisAccountStyled = require("./ArcgisAccount-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// App components
// Third-party components (buttons, icons, etc.)
// JSON
// CSS
var ArcgisAccountContentMenu = function ArcgisAccountContentMenu(_ref) {
  var children = _ref.children,
      user = _ref.user,
      other = _objectWithoutProperties(_ref, ["children", "user"]);

  return _react.default.createElement(_ArcgisAccountStyled.StyledArcgisAccountContentMenu, other, children);
};

ArcgisAccountContentMenu.propTypes = {
  /** Content of the StyledArcgisAccountContentMenu */
  children: _propTypes.default.node,

  /** AGOL user object */
  user: _propTypes.default.object
};
ArcgisAccountContentMenu.defaultProps = {};
ArcgisAccountContentMenu.displayName = 'ArcgisAccountContentMenu';
var _default = ArcgisAccountContentMenu;
exports.default = _default;